import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/bombas/BombasDiafragma.png';
import Img2 from '../../img/products/bombas/BombasDiafragma/BombaDiafragma1.png';

const BombasMultietapas = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Bombas De Diafragma</h2>

      {/* Estilos inline o puedes mover esto a tu CSS */}
      <style>{`
        .img-hover-zoom {
          transition: transform 0.3s ease;
        }

        .img-hover-zoom:hover {
          transform: scale(1.05);
        }
      `}</style>

      <div className="row align-items-start mb-5">
        {/* Columna izquierda: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            Las bombas de diafragma, también conocidas como bombas de membrana, son un tipo de bomba que
             utiliza un diafragma oscilante para mover fluidos. Estas bombas son ampliamente utilizadas 
             en aplicaciones donde se  requiere un manejo preciso y seguro de fluidos corrosivos, abrasivos
              o viscosos, así como en aplicaciones médicas y de laboratorio.
          </p>
          <p className="lead text-justify">
            El diafragma es una membrana flexible que se mueve hacia arriba y hacia abajo para crear un 
            vacío y atraer el fluido hacia la cámara de bombeo. Al regresar, el diafragma empuja el fluido 
            hacia la salida. La cámara de bombeo está completamente sellada, lo que evita la contaminación 
            y garantiza un manejo seguro de fluidos peligrosos.
          </p>
        </div>

        {/* Columna derecha: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-6">
            <div className="col-6">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 1" />
            </div>
            <div className="col-6">
              <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BombasMultietapas;
